<template>
  <div class="contentbox">
    <div v-if="platform == 'wx-sv' || platform == 'wx-gg-sv' " class="platform-box">
      <span>回传平台</span>
      <el-radio-group v-model="returnPlatform" @input="handleReturnPlatform" class="return-platform">
        <el-radio :label="1">巨量回传</el-radio>
        <el-radio :label="2">腾讯广点通回传</el-radio>
      </el-radio-group>
    </div>
    <div class="caretbtn" @click="changeCaret(fromIsOpen)">
      <span>{{ fromIsOpen ? '展开' : '收起' }}</span>
      <i class="el-icon-caret-bottom" v-if="fromIsOpen"></i>
      <i class="el-icon-caret-top" v-else></i>
    </div>
    <!-- 巨量 -->
    <div v-if="returnPlatform == 1" style="height: calc(100% - 64px);">
      <ul class="tabs-ul-list">
        <li v-for="(item, index) in tabName" :key="index">
          <a :class="item.value === tabValue ? 'active' : ''" @click="tabChange(item.value)">{{ item.name }}</a>
        </li>
      </ul>
      <div class="tabs-ul-con" style="padding-top: 30px;height: calc(100% - 64px);">
        <!-- 广告补回传组件 -->
        <ad-return-list v-if="tabValue == 1" :fromIsOpen="fromIsOpen"> </ad-return-list>
        <!-- 付费补回传组件 -->
        <recharge-return-list v-if="tabValue == 2" :fromIsOpen="fromIsOpen"> </recharge-return-list>
      </div>
    </div>
    <!-- 腾讯 -->
    <div v-if="returnPlatform == 2" style="height: calc(100% - 64px);">
      <ul class="tabs-ul-list">
        <li v-for="(item, index) in tabName" :key="index">
          <a :class="item.value === tabValue ? 'active' : ''" @click="tabChange(item.value)">{{ item.name }}</a>
        </li>
      </ul>
      <div class="tabs-ul-con" style="padding-top: 30px;height: calc(100% - 64px);">
        <!-- 广告补回传组件 -->
        <ad-return-list-tx v-if="tabValue == 1" :fromIsOpen="fromIsOpen"> </ad-return-list-tx>
        <!-- 付费补回传组件 -->
        <recharge-return-list-tx v-if="tabValue == 2" :fromIsOpen="fromIsOpen"> </recharge-return-list-tx>
      </div>
    </div>
    <agent-pop :visible.sync="isShowDialogAgent"></agent-pop>
  </div>
</template>
<script>
import AgentPop from '@/components/AgentPop'
import AdReturnList from '@/components/AdReturnList'
import RechargeReturnList from '@/components/RechargeReturnList'
import AdReturnListTx from '@/components/AdReturnListTx'
import RechargeReturnListTx from '@/components/RechargeReturnListTx'
import { list, addRepair } from "@/api/dysvzk/data/return";
export default {
  components: {
    AgentPop,
    AdReturnList,
    RechargeReturnList,
    AdReturnListTx,
    RechargeReturnListTx,
  },
  data() {
    return {
      tabValue: 1,
      loading: false,
      dataTime: [],
      statusBList: [],
      formInline: {
        userId: '',
        statusB: '',
        status: '',
        tfid: '',
        agentId: '',
        promotionid: '',
        startTime: '',
        endTime: ''
      },
      tableData: {
        pageSize: 20,
        pageNo: 1,
        totalPage: 1,
        totalNum: 0,
        result: [
        ]
      },
      currentPage: 1,
      dialogInfoVisible: false,
      rowForm: {},
      statusBOptions: [
        {
          value: 1,
          label: '已回传'
        },
        {
          value: 2,
          label: '已手动回传'
        },
        {
          value: 0,
          label: '未回传'
        }
      ],
      statusOptions: [
        {
          value: -1,
          label: '不符合回传'
        },
        {
          value: 0,
          label: '已漏'
        },
        {
          value: 1,
          label: '已回传'
        }
      ],
      isShowDialogAgent: false,
      tabName: [
        {
          value: 1,
          name: '广告补回传'
        }, {
          value: 2,
          name: '付费补回传'
        },
      ],
      platform: localStorage.getItem('platform'),
      returnPlatform: 1,//回传平台
      fromIsOpen: false,
    }
  },
  computed: {},
  watch: {},
  created() {
    if (JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
      this.isShowDialogAgent = false
    } else {
      this.isShowDialogAgent = true
    }
  },
  mounted: function () {
    this.handleReturnPlatform()
  },
  methods: {
    // 选择回传平台
    handleReturnPlatform(val) {
      console.log("选择回传平台", this.returnPlatform, val)
      if ( this.platform == 'wx-sv' || this.platform == 'wx-gg-sv' ) {
        if(val == 2){
          this.formInline.type = 1
          this.tabValue = 1
          this.typeOptions = [
            {
              value: 1,
              label: '免费回传'
            },
            {
              value: 2,
              label: '付费回传'
            },
          ]
          this.tabName = [
            {
              value: 1,
              name: '广告补回传'
            }, {
              value: 2,
              name: '付费补回传'
            },
          ]
        }else{
          this.formInline.type = 2
          this.tabValue = 2
          this.typeOptions = [
            {
              value: 2,
              label: '付费回传'
            },
          ]
          this.tabName = [
            {
              value: 2,
              name: '付费补回传'
            },
          ]
        }
       
      }
      this.getTableData()
    },
    search () {
      this.currentPage = 1
      this.getTableData()
    },
    resetQuery: function () {
      this.$refs['formInline'].resetFields()
      this.dataTime = []
      this.getTableData()
    },
    // pageSize切换
    handleSizeChange(val) {
      this.tableData.pageSize = val
      this.currentPage = 1
      this.getTableData()
    },
    handleCurrentChange(value) {
      this.currentPage = value
      this.getTableData()
    },
    handleLook(row) {
      this.dialogInfoVisible = true
      this.rowForm = row
    },
    // 删除
    getTableData() {
      let json2 = {
        pageNo: this.currentPage,
        pageSize: this.tableData.pageSize
      };
      this.formInline.statusB = this.statusBList.toString()
      this.formInline.startTime = this.dataTime ? this.dataTime[0] : ''
      this.formInline.endTime = this.dataTime ? this.dataTime[1] : ''
      let json1 = this.formInline;
      let paramJson = { ...json1, ...json2 };
      list(paramJson).then(response => {
        if (response.data.head.flag === 0) {
          this.tableData = response.data.content
        } else {
          this.$message.error(response.data.head.desc)
        }
      });
    },
    repair(id) {
      addRepair({
        infoId: id
      }).then(response => {
        if (response.data.head.flag === 0) {
          this.getTableData()
        } else {
          this.$message.error(response.data.head.desc)
        }
      });
    },
    tabChange(val) {
      this.tabValue = val;
    },
    //展开、收起筛选面板
		changeCaret(value) {
			this.fromIsOpen = !value
			// this.$nextTick(() => {
      //   this.calcTableHeight(); // 表单展开/收起后重新计算表格高度
      // });
		},
  }
}
</script>
<style lang="scss" scoped>
.contentbox{
	height: calc(100% - 64px);
  position: relative;
  .caretbtn {
    color: #409eff;
    font-size: 14px;
		position: absolute;
		right: 30px;
		top: 30px;
		margin-left: 20px;
    cursor: pointer;
    z-index: 1;
	}
}
.media-tab {
  display: flex;

  .media-tab-title {
    width: 120px;
    height: 40px;
    border: 1px solid #afb0b3;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #606266;
    margin-bottom: 20px;
    margin-right: 10px;
  }

  .tab-select {
    color: #409eff;
    border: 1px solid #409eff;
  }
}

.platform-box {
  margin-bottom: 30px;

  .return-platform {
    margin-left: 30px;
  }
}
</style>
